import React from 'react';

import Framework from "@beardeddevops/react.framework";
import UserRoles from "constants/UserRoles";
import Map from "../../../../../components/Containers/FELocationTrack";
import Table from "../../../../../components/Collections/FELocationTable"
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import classNames from "classnames";

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class FELocationTrack extends Framework.Components.View {
	constructor(props) {
		super(props, 'table');

		this.state = {
			...this.state,
			name: '',
		}
	}

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "FELocation",
				url: `/dispatch/felocation`,
				icon: 'compass',
			}
		]);

		let {
			history,
			reloadShell,
			baseUrl,
			roles,
		} = this.props;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Map" value="map"/>
					<Tab label="Table" value="table"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'map'})}>
					<Map
						history={history}
						baseUrl={baseUrl}
						reloadShell={reloadShell}
						roles={roles}
						refresh={this.state.refresh}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'table'})}>
					<Table
						history={history}
						baseUrl={baseUrl}
						reloadShell={reloadShell}
						roles={roles}
						refresh={this.state.refresh}
					/>
				</div>
			</div>
		);
	}
}


